<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('customer-management')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>

      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("create_customer") }}
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <customer-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :companyData="companyData"
      @close-modal="closeAddEditModal"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../Config/ApiUrl";
import { TableHelpers } from "../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../core/helpers/app/AppFunction";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  props: {
    sectionTitle: String
  },
  data() {
    return {
      companyData: {
        company_admin:{}
      },
      jobTitle: "view-customer-job",
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "customer-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.CUSTOMER_LIST,
        showHeader: true,
        columns: [
          {
            title: this.$t("id"),
            type: "custom-html",
            key: "id",
            modifier: (value, row) => {
              return `<span>${('sc-' +value +'-'+ row.company_admin.id)}</span>`;
            },
            isVisible: true,
          },
          {
            title: this.$t("company_name"),
            type: "custom-html",
            key: "company_name",
            modifier: (value, row) => {
              return `<span>${(value)}</span>`;
            },
            isVisible: true,
          },
          {
            title: this.$t("admin"),
            type: "custom-html",
            key: "company_admin",
            modifier: (value, row) => {
              return `<span>${(value.full_name)}</span>`;

            },
            isVisible: true,
          },


          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("No. of Jobs"),
            type: "custom-html",
            key: "jobs_count",
            modifier: (value) => {
              return `<span>${value}</span>`;
            },
          },
          {
            title: this.$t("No. Of Records"),
            type: "custom-html",
            key: "company_admin",
            modifier: (value) => {
              return `<span>${value.mydocument_count??'---'}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.setCustomerJobs(),
            icon: "clipboard",
            type: "none"
          },
          {
            title: this.$t("view-customer-profile"),
            icon: "clipboard",
            type: "none"
          },
          {
            title: this.$t("view-customer-records"),
            icon: "clipboard",
            type: "none"
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "demo-delete",
          },
        ],
        filters: [
          {
            title: this.$t("date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "nextYear"],
          },

          {
            title: this.$t("search_and_select"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {

    this.jobTitle = this.sectionTitle;
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal(companyData) {
      this.isAddEditModalActive = true;
      if (companyData.company_admin){
        this.companyData = companyData
      }else{
        this.companyData = {
          company_admin: {}
        }
      }

    },
    setCustomerJobs(){
      let title = this.sectionTitle??"view-customer-jobs";
      return this.$t(title);
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.CUSTOMER_SHOW}/${rowData.id}`;
        this.openAddEditModal(rowData);
      }
      else if (actionObj.title == this.$t("view-customer-jobs") || actionObj.title == this.$t("Contract Management")) {
        this.active = 1
        this.$emit('customerCompanyId',rowData.id,this.active);
      }
      else if (actionObj.title == this.$t("view-customer-profile")) {

        this.active = 6
        this.$emit('customerCompany',rowData,this.active);
      }
      else if (actionObj.title == this.$t("view-customer-records")) {
        this.active = 7
        this.$emit('customerCompany',rowData,this.active);
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      // alert(`${actions.CUSTOMER_DESTROY}/${this.rowData.id}`);
      let url = `${actions.CUSTOMER_DESTROY}/${this.rowData.id}`;

      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.CUSTOMER_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
  },
};
</script>
